package com.wintermar.inspection.feature.domain.model.template

data class TemplateModel(
    val data: List<InspectionTemplateModel> = emptyList(),
    val total: Int = 0
)
